import { cssColorValue, PopoverNavigation, semanticColors, spacer20, spacer64 } from '@spotify-internal/encore-web';
import React from 'react';
import styled from 'styled-components';

import { useTranslation } from 'providers/translations/TranslationProvider';
import { MastheadHeaderData } from 'lib/sanity/types';
import { NavBarLanguagePicker } from 'components/Masthead/Header/LanguagePicker';
import { SideMenuSecondaryLinks } from 'components/Masthead/Header/SideMenu/SecondaryLinks';
import { SideMenuPrimaryLinks } from 'components/Masthead/Header/SideMenu/PrimaryLinks';
import { SideMenuNavigationList } from 'components/Masthead/Header/SideMenu/Shared';

const SideMenuNavigation = styled(PopoverNavigation)`
  background: ${cssColorValue(semanticColors.backgroundBase)};
  bottom: 0;
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding: ${spacer64} ${spacer20} ${spacer20};
  position: fixed;
  inset-inline-end: 0;
  top: 0;
  width: 280px;

  &&:focus {
    outline: none;
  }
`;

type Props = {
  headerEntry: MastheadHeaderData;
  closeBackdrop: () => void;
  dir: string;
};

export const NavBarSideMenu = ({ headerEntry: { secondaryLinks, primaryLinks }, closeBackdrop, dir }: Props) => {
  const { t } = useTranslation();
  return (
    <SideMenuNavigation as="nav" dir={dir} role="dialog" tabIndex={0} aria-label={t('navbar_side_menu_popover_label')}>
      <SideMenuNavigationList $variant="default">
        <SideMenuSecondaryLinks secondaryLinks={secondaryLinks} closeBackdrop={closeBackdrop} />
        <SideMenuPrimaryLinks primaryLinks={primaryLinks} closeBackdrop={closeBackdrop} />
      </SideMenuNavigationList>
      <div>
        <NavBarLanguagePicker container="sidemenu" />
      </div>
    </SideMenuNavigation>
  );
};
